import React from 'react';
import { X, Check } from 'lucide-react';
const rows = [{
  before: 'Attività da cercare ogni settimana',
  after: 'Lezioni pronte e strutturate'
}, {
  before: "Verifiche create all'ultimo minuto",
  after: 'Verifiche e rubriche già preparate'
}, {
  before: 'Programmazione incompleta o frammentata',
  after: 'Programmazione annuale completa'
}, {
  before: 'Studenti poco coinvolti',
  after: 'Dibattiti e compiti di realtà pronti'
}, {
  before: 'Stress costante per le scadenze',
  after: 'Più tempo libero per te'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-dark py-24 px-4" data-id="element-34">
      <div className="max-w-5xl mx-auto" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-37">
            Il tuo lavoro, prima e dopo
          </h2>
        </div>

        <div className="bg-bg-main rounded-3xl shadow-xl border border-border-light overflow-hidden" data-id="element-38">
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-bg-alt" data-id="element-39">
            <div className="px-6 py-6 font-bold text-slate-500 text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm uppercase" data-id="element-40">
              Senza Educazione Civica Pronta
            </div>
            <div className="px-6 py-6 font-black text-primary text-center md:text-left tracking-wider text-sm uppercase bg-primary/5" data-id="element-41">
              Con Educazione Civica Pronta
            </div>
          </div>

          <div className="divide-y divide-border-light" data-id="element-42">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-slate-50/50 transition-colors" data-id="element-43">
                <div className="px-6 py-6 flex items-center gap-4 border-b md:border-b-0 md:border-r border-border-light" data-id="element-44">
                  <div className="w-8 h-8 rounded-full bg-badge-red/10 flex items-center justify-center flex-shrink-0 border border-badge-red/20" data-id="element-45">
                    <X className="w-4 h-4 text-badge-red" data-id="element-46" />
                  </div>
                  <p className="text-text-sec font-medium text-lg" data-id="element-47">
                    {row.before}
                  </p>
                </div>
                <div className="px-6 py-6 flex items-center gap-4 bg-primary/[0.02] relative overflow-hidden" data-id="element-48">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-49"></div>
                  <div className="w-8 h-8 rounded-full bg-check-green/10 flex items-center justify-center flex-shrink-0 border border-check-green/20 relative z-10" data-id="element-50">
                    <Check className="w-4 h-4 text-check-green stroke-[3]" data-id="element-51" />
                  </div>
                  <p className="text-text-main font-bold text-lg relative z-10" data-id="element-52">
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}